function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D1DAE3;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F6F9FB;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Hi-Fi-"
}, /*#__PURE__*/React.createElement("g", {
  id: "_x31_.-Calendar-No-Store-Selected",
  transform: "translate(-757.000000, -384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "No-Store-Selected",
  transform: "translate(716.000000, 384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Store-Illustration",
  transform: "translate(41.184107, 0.981039)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st0",
  d: "M153.5,45.4c0.1,0.4,0.1,0.9,0.1,1.5c0,3,0,6,0.1,9c0.1,5.7,0.1,11.6,0.1,17.3V106v0.8 c0,1.6-1.3,2.8-2.9,2.8h-7.6c-2.2,0-4-1.8-4-4V50.6c0-1.7-1.4-3.1-3.1-3.1H109c-1.7,0-3.1,1.4-3.1,3.1v55.1c0,2.2-1.8,4-4,4h-86 c-1.6,0-2.9-1.3-2.9-2.8V45.3c0-3.2,5.9-4.9,8.2-5.9c2.1-0.9,3.3-0.4,5.1,0.9c3.3,2.3,7.5,3.1,11.5,2.4c2.1-0.4,4.1-1.1,5.8-2.3 c1.2-0.8,2.5-2,4-1.5c0.7,0.2,1.3,0.7,1.8,1.1c5.4,3.8,12.6,4,18,0.1c0.9-0.6,1.8-1.4,2.8-1.4c1.8,0,3.3,1.6,4.8,2.4 c1.5,0.9,3.3,1.4,5,1.7c2.9,0.4,5.8,0,8.5-1.2c3.8-1.7,5-3.5,9-1.2c2.4,1.4,5.2,2.4,8.1,2.5c2.7,0.1,5.5-0.5,7.7-2 c2-1.3,3.8-3.3,6.2-1.5c5.7,4.4,14.2,4.8,19.7-0.1c2-1.8,3.2-1.3,5.2,0.2c1.9,1.4,3.9,2.5,6.3,3 C152.7,42.9,153.3,43.8,153.5,45.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  className: "st0",
  d: "M139.3,50.6v59.1h-33.4V50.6c0-1.7,1.4-3.1,3.1-3.1h27.2C137.9,47.5,139.3,48.8,139.3,50.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-5",
  className: "st1",
  d: "M109,47.5c-1.7,0-3.1,1.4-3.1,3.1v59.1h33.4V50.6c0-1.7-1.4-3.1-3.1-3.1H109z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-7",
  className: "st1",
  d: "M26.5,52.7v42.7c0,2.9,2.3,5.2,5.2,5.2h56.2c2.9,0,5.2-2.3,5.2-5.2V52.7c0-2.9-2.3-5.2-5.2-5.2 H31.7C28.8,47.5,26.5,49.8,26.5,52.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M85.2,50c2.6,0,4.7,2.1,4.7,4.7l0,0v38.7c0,2.6-2.1,4.7-4.7,4.7l0,0H34.4 c-2.6,0-4.7-2.1-4.7-4.7l0,0V54.7c0-2.6,2.1-4.7,4.7-4.7l0,0H85.2z M82.6,52.5H37c-2.3,0-4.2,1.9-4.2,4.2v34.7 c0,2.3,1.9,4.2,4.2,4.2h45.6c2.3,0,4.2-1.9,4.2-4.2V56.7C86.8,54.4,84.9,52.5,82.6,52.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-13",
  className: "st0",
  d: "M151.9,118.2H15c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7h136.9c1.5,0,2.7,1.2,2.7,2.7 S153.4,118.2,151.9,118.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-17",
  className: "st0",
  d: "M113.4,51.3c-3.1,0-4.7,1.2-4.7,4.4l0,0c0.1,16.5,0,33.1,0,49.6l0,0c0,2.9,1.4,4.3,4.5,4.2 l0,0c6.1-0.1,12.3-0.1,18.4,0l0,0c3.9,0.1,5.1-1.6,5-5l0,0c-0.1-7.9,0-15.8-0.1-23.7l0,0c0-8.3-0.1-16.7,0-25l0,0 c0-3.2-1.4-4.5-4.7-4.5l0,0c-6.1,0.1-12.3,0.1-18.4,0l0,0C113.5,51.3,113.4,51.3,113.4,51.3L113.4,51.3z M111.8,58.2 c0-2.8,1.5-4,4.3-3.9l0,0c4.4,0,8.9,0,13.3,0l0,0c2.6,0,4,1.2,4.1,3.7l0,0c0,0.1,0,0.3,0,0.4l0,0c0.2,11.6,0.6,11.5-7.1,11.4 l0,0c-1.1,0-2.3,0-3.7,0l0,0c-1.5,0-2.8,0-3.9,0l0,0c-0.7,0-1.3,0-1.9,0l0,0C111.2,69.8,111.7,68.9,111.8,58.2L111.8,58.2z  M128.6,72.6c3.5-0.1,5.1,1.3,5,4.7l0,0c-0.1,4.2,0,8.5,0,12.7l0,0c0,4.1-0.1,8.2,0,12.3l0,0c0,2.9-1.3,4.3-4.4,4.3l0,0 c-4.3-0.1-8.6-0.1-12.9,0l0,0c-3,0-4.5-1.1-4.5-4.2l0,0c0.1-8.5,0.1-17,0-25.5l0,0c0-3.2,1.6-4.4,4.8-4.4l0,0 c2.1,0,4.1,0.1,6.2,0.1l0,0C124.7,72.7,126.6,72.7,128.6,72.6L128.6,72.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-20",
  className: "st0",
  d: "M102.1,0.2c-1.2,0-2.5,0-4,0l0,0c-3.4,0-5,1.3-4.5,5l0,0c0.5,4.1,1,8.1,1.2,12.2l0,0 c0.6,11,1.3,10.9,8.1,10.9l0,0c1.1,0,2.3,0,3.8,0l0,0c11.6,0,10.7,0.8,8.6-10.9l0,0c-0.3-1.5-0.6-3-0.9-4.5l0,0 c-2.6-11.8-0.9-12.6-9.6-12.6l0,0C103.9,0.2,103.1,0.2,102.1,0.2L102.1,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-23",
  className: "st0",
  d: "M57.9,0.2c-3.5,0-5.2,1.6-5.8,5l0,0c-0.7,4.2-1.7,8.4-2.5,12.6l0,0c-2,10.6-2.9,10.5,6.5,10.5 l0,0c0.6,0,1.3,0,2.1,0l0,0c1.2,0,2.3,0,3.3,0l0,0c7.9,0,8.1,0.1,8.7-10.7l0,0c0.1-1.4,0.5-2.7,0.5-4.1l0,0 c0.5-12.2,4-13.3-7.5-13.3l0,0C61.8,0.2,60,0.2,57.9,0.2L57.9,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-26",
  className: "st0",
  d: "M45.8,0.2c-2.8,0.2-5.7,0.1-8.5,0l0,0c-3.1-0.1-5,1.2-5.8,4.3l0,0C30.4,9,29,13.4,27.7,17.8 l0,0c-3.1,10.5-3.1,10.5,7.7,10.5l0,0c1.2,0,2.3-0.1,3.5,0l0,0c5.1,0.7,7.6-1.5,8.3-6.8l0,0c0.6-5.2,1.9-10.4,3-15.6l0,0 c0.8-3.6,0.1-5.7-3.6-5.7l0,0C46.3,0.1,46.1,0.2,45.8,0.2L45.8,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-29",
  className: "st0",
  d: "M9.5,4.7C8,9.2,6.1,13.6,4.4,18l0,0c-4,10.2-4,10.2,6.8,10.2l0,0c2.2,0,4.3,0,6.5,0l0,0 c2.2,0,3.9-0.8,4.6-3.2l0,0c2-6.9,4-13.8,6-20.6l0,0c0.7-2.6-0.3-4-2.9-4.1l0,0c-3.2-0.1-6.3,0-9.5-0.1l0,0c-0.2,0-0.3,0-0.5,0 l0,0C12.4,0.2,10.6,1.6,9.5,4.7L9.5,4.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-32",
  className: "st0",
  d: "M123.6,0.2c-1.2,0-2.6,0-4.1,0l0,0c-0.2,0-0.5,0-0.7,0l0,0c-0.3,0-0.5,0-0.8,0l0,0 c-2.9-0.1-3.9,1.4-3.4,4.2l0,0c0.9,4.5,1.8,9,2.7,13.6l0,0c2,10.3,1.4,10.2,9.3,10.2l0,0c0.8,0,1.8,0,2.8,0l0,0 c1.8,0,3.7-0.1,5.5,0l0,0c4.3,0.2,5.3-1.8,4-5.7l0,0c-1.1-3.4-2-6.9-3.1-10.3l0,0c-3.7-11.3-1.8-12-10.2-12l0,0 C125,0.2,124.3,0.2,123.6,0.2L123.6,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-35",
  className: "st0",
  d: "M140.3,0.2c-4.6,0-5.3,2.1-4,6.1l0,0c1.6,5,3.4,10.1,4.5,15.2l0,0c1.1,5.4,4,7.6,9.3,6.8l0,0 c1-0.2,2,0,3.1,0l0,0v0c1.9,0,3.8-0.1,5.6,0l0,0c4.3,0.2,5.1-1.7,3.5-5.4l0,0c-1.6-3.8-3-7.6-4.6-11.4l0,0 C153,0.2,155.2,0.2,144.9,0.2l0,0c-1.3,0-2.7,0-4.4,0l0,0C140.4,0.2,140.4,0.2,140.3,0.2L140.3,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-38",
  className: "st0",
  d: "M73.6,5.7c-0.3,4.1-0.8,8.2-1.1,12.2l0,0c-0.8,10.3-0.7,10.3,9.1,10.3l0,0c0.5,0,1,0,1.5,0 l0,0c1,0,1.9,0,2.9,0l0,0c5.8-0.1,6.2-0.6,5.7-6.5l0,0c-0.4-4.6-0.9-9.2-1.3-13.8l0,0c-0.6-7.5-0.8-7.7-7.9-7.8l0,0 c-0.4,0-0.7,0-1.1,0l0,0c-0.6,0-1.3,0-1.9,0l0,0c-0.3,0-0.6,0-0.8,0l0,0C75.5,0.2,73.8,2,73.6,5.7L73.6,5.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-41",
  className: "st0",
  d: "M145,32.6c-0.5,2.6,2,4.2,4.1,5.6l0,0c1.5,1,3.3,1.5,5.7,1.5l0,0c3.3-0.1,6.4-1.6,8.4-5l0,0 c0.6-1,1.1-2.4,0.2-3.3l0,0c-0.8-0.8-2.4-0.8-3.5-0.8l0,0c-0.2,0-0.4,0-0.5,0l0,0c-1,0-2,0-3.1,0l0,0c-2.2,0-4.4,0-6.7-0.1l0,0 c-0.5,0-1-0.1-1.5-0.1l0,0C146.7,30.6,145.3,30.9,145,32.6L145,32.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-44",
  className: "st0",
  d: "M124.6,30.8c-0.2,0-0.4,0-0.6,0l0,0c-1.1,0-2.3,0-2.9,1.2l0,0c-0.8,1.6,0.4,2.9,1.2,4l0,0 c4.1,5.4,12.1,5.3,16-0.1l0,0c0.8-1.1,1.7-2.2,1.2-3.6l0,0c-0.5-1.6-2-1.4-3.3-1.5l0,0c-1.4,0-2.7,0-4.1,0l0,0 c-0.6,0-1.2,0-1.8,0l0,0c-1.2,0-2.4,0-3.5,0l0,0C126.1,30.8,125.3,30.8,124.6,30.8L124.6,30.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-47",
  className: "st0",
  d: "M97.8,32.2c-0.5,1.4,0.5,2.5,1.3,3.6l0,0c3.7,4.8,10.5,5.4,15,1.3l0,0c1.4-1.3,3.4-2.8,2.5-5 l0,0c-0.6-1.4-2.6-1.3-4.1-1.2l0,0c-0.4,0-0.7,0-1,0l0,0c-1.3,0-2.6,0-3.8,0l0,0c-1.1,0-2.3,0-3.4,0l0,0c-0.8,0-2-0.2-3.1-0.2 l0,0C99.6,30.8,98.2,31,97.8,32.2L97.8,32.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-50",
  className: "st0",
  d: "M74.8,30.6c-1,0.1-1.7,0.7-2,1.7l0,0c-0.8,3.1,2.2,4.8,4.6,6.3l0,0c1.4,0.9,3.1,1.2,4.8,1.2 l0,0c3.8-0.1,6.7-1.9,8.7-5l0,0c1.1-1.6,0.9-3.4-1.1-3.9l0,0c-2.4-0.7-5-0.3-7.5-0.3l0,0c-1.6,0-3.2-0.1-4.8-0.1l0,0 C76.6,30.4,75.7,30.5,74.8,30.6L74.8,30.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-53",
  className: "st0",
  d: "M48.5,32.6c-0.5,2.6,2.1,4.3,4.2,5.7l0,0c1.5,1,3.3,1.5,5.2,1.5l0,0c3.4,0,6.1-1.5,8.2-4.1 l0,0c0.9-1,1.8-2.2,1.3-3.5l0,0c-0.6-1.5-2.1-1.4-3.4-1.4l0,0c-3.8-0.1-7.7-0.1-11.5-0.1l0,0c-0.1,0-0.2,0-0.4,0l0,0 C50.5,30.7,48.9,30.8,48.5,32.6L48.5,32.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-56",
  className: "st0",
  d: "M35.1,30.8c-1.4,0-2.9,0-4.3,0l0,0c-1.4,0-2.8,0-4.2,0.4l0,0c-0.5,0.2-1,0.4-1.3,0.9l0,0 c-0.4,0.7-0.1,1.5,0.2,2.2l0,0c1,2.2,2.8,3.9,5,4.9l0,0c2.2,1,4.7,1.1,6.9,0.4l0,0c2.3-0.7,4.2-2.2,5.7-4.1l0,0 c0.5-0.6,0.9-1.2,1-1.9l0,0c0.3-1.7-1.1-2.8-2.6-2.8l0,0c-0.7,0-1.3-0.1-2-0.1l0,0C38.1,30.7,36.6,30.8,35.1,30.8L35.1,30.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clip-59",
  className: "st0",
  d: "M13.4,30.7c-0.9,0-1.8,0-2.7,0l0,0c-0.7,0-1.4,0-2,0l0,0c-1.3,0-2.6,0-3.9,0l0,0 c-0.2,0-0.4,0-0.6,0l0,0c-1.1,0-2.3,0-2.9,1.2l0,0c-0.7,1.6,0.4,2.8,1.3,4l0,0c4,4.9,10.9,5.1,15.3,0.6l0,0c1-1,2.2-2.1,2.2-3.5 l0,0v0c0-0.2,0-0.5-0.1-0.7l0,0c-0.5-1.7-1.9-1.6-3.2-1.6l0,0c-0.4,0-0.7,0-1,0l0,0c-0.5,0-1.1-0.1-1.6-0.1l0,0H13.4z"
})))));

var SvgNoStoreSelected = function SvgNoStoreSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 120",
    style: {
      enableBackground: "new 0 0 165 120"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoStoreSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-store-selected.7f446428.svg";
export { ForwardRef as ReactComponent };